const getUrlSearchParam = (queryString: string, key: string) => {
  const urlParams = new URLSearchParams(queryString);

  return urlParams.get(key) as string | undefined;
};

export default getUrlSearchParam;
